import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function DocumentsActive(props) {
  const { id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const format = new DateUtils();

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(`/api/company/${id}`)
      .then(async (res) => {
        await axios
          .get(
            `/api/document?page=${page}&search=${search}&company_id=${res.data.data._id}&status=active`
          )
          .then(async (res) => {
            setLoading(false);
            setPayload(res.data.data);

            var tempData = [];

            const timezone = await format.getTimezone();

            res.data.data.data.map((value, index) => {
              if (value.updated_at === value.createdAt) {
                value.updated_at = '';
              }

              tempData.push({
                id: value.id,
                name: value.name,
                type: value.type.replaceAll('_', ' '),
                link: value.s3_link,
                uploaded_by: value.uploaded_by,
                uploaded_at: format.timestamp(
                  value.createdAt,
                  timezone
                ),
                updated_by: value.updated_by,
                updated_at: value.updated_at
                  ? format.timestamp(value.updated_at, timezone)
                  : '',
              });
            });

            setData(tempData);
          })
          .catch((err) => {
            setLoading(false);

            context.notification.show(
              'Failed to load table data',
              'error',
              true,
              'toast',
              'x-circle'
            );
          });
      })
      .catch((err) => {
        console.log(err);

        context.notification.show(
          'Something went wrong!',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  async function archiveDocument(id) {
    setLoading(true);

    await axios
      .patch(`/api/document/${id}`, { status: 'archived' })
      .then((res) => {
        setLoading(false);

        runAPI(page, searchQueryString);

        context.notification.show(
          'Document arquived!',
          'success',
          true,
          'toast',
          'check-circle'
        );
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          'Failed to arquive document.',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  function editDocument(document) {
    setModal({
      name: 'documents_modal',
      data: document,
      mode: 'edit',
      action: () => runAPI(page, searchQueryString),
    });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, '');
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              width: '150px',
              backgroundColor: 'black',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'default',
            }}
          >
            Active
          </div>
          <div
            onClick={() => {
              window.location.href =
                '/app/company/' + id + '/documents/archived';
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '150px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Archived
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <IconedButton
            size="160px"
            color="#d32425"
            textColor="white"
            icon="plus-circle"
            text="Add Document"
            marginRight
            action={() =>
              setModal({
                name: 'documents_modal',
                action: () => runAPI(page, searchQueryString),
              })
            }
          />
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              badge={{ col: 'type', color: 'gray' }}
              hide={['link', 'id']}
              actions={{
                custom: [
                  {
                    icon: 'download-cloud',
                    tooltip: 'Download this document',
                    action: (row) => {
                      window.open(row.link);
                    },
                  },
                  {
                    icon: 'edit',
                    tooltip: 'Edit this document',
                    action: (row) => {
                      editDocument(row);
                    },
                  },
                  {
                    icon: 'archive',
                    tooltip: 'Archive this document',
                    action: (row) => {
                      archiveDocument(row.id);
                    },
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
